<section class="hd-planet-cheat-sheet-page">
  <e-card2 class="hd-planet-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-planet-cheat-sheet-page__controls" aria-label="Planet cheat sheet controls">
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="hd-planet-cheat-sheet-page__divider"></span>

      <button
        eBtn
        size="sm"
        squared
        type="button"
        icon="clock"
        [color]="hideCycleInfo() ? 'highlight' : 'primary-75'"
        [iconColor]="hideCycleInfo() ? 'primary-75' : undefined"
        tooltip="Cyclus-info tonen / verbergen"
        (click)="toggleHideCycleInfo()"
      ></button>

      <button
        eBtn
        size="sm"
        squared
        type="button"
        icon="heading"
        [color]="hideSubtitle() ? 'highlight' : 'primary-75'"
        [iconColor]="hideSubtitle() ? 'primary-75' : undefined"
        tooltip="Subtitel tonen / verbergen"
        (click)="toggleHideSubtitle()"
      ></button>

      <button
        eBtn
        size="sm"
        squared
        type="button"
        icon="list"
        [color]="hideBullets() ? 'highlight' : 'primary-75'"
        [iconColor]="hideBullets() ? 'primary-75' : undefined"
        tooltip="Bullets tonen / verbergen"
        (click)="toggleHideBullets()"
      ></button>
    </div>
  </e-card2>

  <div class="hd-planet-cheat-sheet-page__grid">
    @for (planet of planets; track planet.key) {
      <hd-planet-card
        [planetKey]="planet.key"
        [hideCycleInfo]="hideCycleInfo()"
        [hideSubtitle]="hideSubtitle()"
        [hideBullets]="hideBullets()"
      />
    }

    <article class="hd-planet-cheat-sheet-page__legend">
      <header class="hd-planet-cheat-sheet-page__legend-header">
        <h3 class="hd-planet-cheat-sheet-page__legend-title">{{ legend().title }}</h3>
        <span class="hd-planet-cheat-sheet-page__legend-note">{{ legend().note }}</span>
      </header>

      <div class="hd-planet-cheat-sheet-page__legend-columns">
        @for (column of legend().columns; track $index) {
          <div class="hd-planet-cheat-sheet-page__legend-column">
            @for (group of column; track $index) {
              <div class="hd-planet-cheat-sheet-page__legend-group">
                @if (group.title) {
                  <div class="hd-planet-cheat-sheet-page__legend-group-title">{{ group.title }}</div>
                }
                @if (group.subtitle) {
                  <div class="hd-planet-cheat-sheet-page__legend-group-subtitle">{{ group.subtitle }}</div>
                }
                <ul class="hd-planet-cheat-sheet-page__legend-items">
                  @for (item of group.items; track $index) {
                    <li class="hd-planet-cheat-sheet-page__legend-item">
                      <span
                        class="hd-planet-cheat-sheet-page__legend-dot"
                        [style.background-color]="item.color"
                      ></span>
                      <span>{{ item.label }}</span>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        }
      </div>
    </article>
  </div>
</section>
